module.exports = __webpack_public_path__ + "sunsemweb/img/ban.a19ba3c6.png";